module.exports = __webpack_public_path__ + "static/media/img_system1.fdf54241.png";